module.exports = __webpack_public_path__ + "img/pastefy.ba4ed4b9.png";